// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAirplane = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M9.555 12.832l-1.11-1.664a6.41 6.41 0 017.11 0l-1.11 1.664a4.41 4.41 0 00-4.89 0" />,
    <path
      fillRule="evenodd"
      d="M5.07 14a7.002 7.002 0 0013.86 0H20v1h2v-1h1v-2h-4.07A7 7 0 0013 6.07V4h-2v2.07A7.005 7.005 0 005.07 12H1v2h1v1h2v-1zM7 13a5 5 0 1110 0 5 5 0 01-10 0"
    />
  );
export default SvgIconAirplane;
